const UpgradeConfig = {
  OPTIONS_COUNT: 3, // 레벨업 시 보여줄 선택지 개수
  CLASSES: {
    KNIGHT: {
      NAME: "용사",
      COLOR: "#DC143C", // 홍적색 (crimson)
      UPGRADES: {
        SWORD: {
          NAME: "검",
          MAX_LEVEL: 10,
          EFFECTS: [
            { ATTACK_DAMAGE: 0.2 },
            { ATTACK_COOLTIME: -0.1 },
            { ATTACK_DAMAGE: 0.4 },
            { ATTACK_COOLTIME: -0.2 },
            { ATTACK_DAMAGE: 0.6 },
            { ATTACK_COOLTIME: -0.3 },
            { ATTACK_DAMAGE: 0.8 },
            { ATTACK_COOLTIME: -0.4 },
            { ATTACK_DAMAGE: 1.0 },
            { ATTACK_COOLTIME: -0.5 },
          ],
          DESCRIPTIONS: [
            "공격력 +20%",
            "공격속도 +10%",
            "공격력 +40%",
            "공격속도 +10%",
            "공격력 +60%",
            "공격속도 +10%",
            "공격력 +80%",
            "공격속도 +10%",
            "공격력 +100%",
            "공격속도 +10%",
          ],
        },
        SHIELD: {
          NAME: "방패",
          MAX_LEVEL: 10,
          EFFECTS: [
            { MAX_HEALTH: 0.2 },
            { MAX_HEALTH: 0.4 },
            { MAX_HEALTH: 0.6 },
            { MAX_HEALTH: 0.8 },
            { MAX_HEALTH: 1.0 },
            { MAX_HEALTH: 1.2 },
            { MAX_HEALTH: 1.4 },
            { MAX_HEALTH: 1.6 },
            { MAX_HEALTH: 1.8 },
            { MAX_HEALTH: 2.0 },
          ],
          DESCRIPTIONS: [
            "체력 +20%",
            "체력 +40%",
            "체력 +60%",
            "체력 +80%",
            "체력 +100%",
            "체력 +120%",
            "체력 +140%",
            "체력 +160%",
            "체력 +180%",
            "체력 +200%",
          ],
        },
      },
    },
  },
  // 동료 시스템 (궁수, 바바리안, 마법사)
  COMPANIONS: {
    ROGUE: {
      NAME: "궁수",
      COLOR: "#228B22", // 초록색 (forestgreen)
      MAX_LEVEL: 1, // 동료 하나당 최대 레벨
      EFFECTS: [],
      DESCRIPTIONS: ["관통하는 화살을 발사합니다."],
    },
    MAGE: {
      NAME: "마법사",
      COLOR: "#8B008B", // 보라색 (darkmagenta)
      MAX_LEVEL: 1,
      EFFECTS: [],
      DESCRIPTIONS: ["동료를 치유하고 주변을 공격합니다."],
    },
    BARBARIAN: {
      NAME: "바바리안",
      COLOR: "#708090", // 남회색 (slategray)
      MAX_LEVEL: 1,
      EFFECTS: [],
      DESCRIPTIONS: ["체력이 높고 강력한 근접 공격을 합니다."],
    },
  },
  PARTY_BUFFS: {
    COLOR: "#444411", // 파티 버프 통일 색상
    ATTACK_DAMAGE: {
      NAME: "공격력",
      MAX_LEVEL: 10,
      EFFECTS: [
        { ATTACK_DAMAGE: 0.2 },
        { ATTACK_DAMAGE: 0.4 },
        { ATTACK_DAMAGE: 0.6 },
        { ATTACK_DAMAGE: 0.8 },
        { ATTACK_DAMAGE: 1.0 },
        { ATTACK_DAMAGE: 1.2 },
        { ATTACK_DAMAGE: 1.4 },
        { ATTACK_DAMAGE: 1.6 },
        { ATTACK_DAMAGE: 1.8 },
        { ATTACK_DAMAGE: 2.0 },
      ],
      DESCRIPTIONS: [
        "공격력 +20%",
        "공격력 +40%",
        "공격력 +60%",
        "공격력 +80%",
        "공격력 +100%",
        "공격력 +120%",
        "공격력 +140%",
        "공격력 +160%",
        "공격력 +180%",
        "공격력 +200%",
      ],
    },
    ATTACK_RANGE: {
      NAME: "공격범위",
      MAX_LEVEL: 10,
      EFFECTS: [
        { ATTACK_RANGE: 0.2 },
        { ATTACK_RANGE: 0.4 },
        { ATTACK_RANGE: 0.6 },
        { ATTACK_RANGE: 0.8 },
        { ATTACK_RANGE: 1.0 },
        { ATTACK_RANGE: 1.2 },
        { ATTACK_RANGE: 1.4 },
        { ATTACK_RANGE: 1.6 },
        { ATTACK_RANGE: 1.8 },
        { ATTACK_RANGE: 2.0 },
      ],
      DESCRIPTIONS: [
        "공격범위 +20%",
        "공격범위 +40%",
        "공격범위 +60%",
        "공격범위 +80%",
        "공격범위 +100%",
        "공격범위 +120%",
        "공격범위 +140%",
        "공격범위 +160%",
        "공격범위 +180%",
        "공격범위 +200%",
      ],
    },
    ATTACK_COOLTIME: {
      NAME: "공격속도",
      MAX_LEVEL: 9,
      EFFECTS: [
        { ATTACK_COOLTIME: -0.1 },
        { ATTACK_COOLTIME: -0.2 },
        { ATTACK_COOLTIME: -0.3 },
        { ATTACK_COOLTIME: -0.4 },
        { ATTACK_COOLTIME: -0.5 },
        { ATTACK_COOLTIME: -0.6 },
        { ATTACK_COOLTIME: -0.7 },
        { ATTACK_COOLTIME: -0.8 },
        { ATTACK_COOLTIME: -0.9 },
      ],
      DESCRIPTIONS: [
        "공격속도 +10%",
        "공격속도 +20%",
        "공격속도 +30%",
        "공격속도 +40%",
        "공격속도 +50%",
        "공격속도 +60%",
        "공격속도 +70%",
        "공격속도 +80%",
        "공격속도 +90%",
      ],
    },
    MOVE_SPEED: {
      NAME: "이동속도",
      MAX_LEVEL: 5,
      EFFECTS: [
        { MOVE_SPEED: 0.2 },
        { MOVE_SPEED: 0.4 },
        { MOVE_SPEED: 0.6 },
        { MOVE_SPEED: 0.8 },
        { MOVE_SPEED: 1.0 },
      ],
      DESCRIPTIONS: [
        "이동속도 +20%",
        "이동속도 +40%",
        "이동속도 +60%",
        "이동속도 +80%",
        "이동속도 +100%",
      ],
    },
    MAX_HP: {
      NAME: "최대체력",
      MAX_LEVEL: 10,
      EFFECTS: [
        { MAX_HEALTH: 0.2 },
        { MAX_HEALTH: 0.4 },
        { MAX_HEALTH: 0.6 },
        { MAX_HEALTH: 0.8 },
        { MAX_HEALTH: 1.0 },
        { MAX_HEALTH: 1.2 },
        { MAX_HEALTH: 1.4 },
        { MAX_HEALTH: 1.6 },
        { MAX_HEALTH: 1.8 },
        { MAX_HEALTH: 2.0 },
      ],
      DESCRIPTIONS: [
        "최대체력 +20%",
        "최대체력 +40%",
        "최대체력 +60%",
        "최대체력 +80%",
        "최대체력 +100%",
        "최대체력 +120%",
        "최대체력 +140%",
        "최대체력 +160%",
        "최대체력 +180%",
        "최대체력 +200%",
      ],
    },
  },
};

// webpack 빌드를 위해 default export 추가
export default UpgradeConfig;

// 전역 변수로도 등록 (기존 코드 호환성)
window.UpgradeConfig = UpgradeConfig;
